// import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
// import { FormControl, FormGroup, Validators } from '@angular/forms';
// import indiaStates from '../../../../../../../assets/js/india.state.list.json';
// import { Observable } from 'rxjs';
// import { map, startWith } from 'rxjs/operators';
// import { StorageService } from 'src/app/Services/storage.service';
// import { ApiService } from 'src/app/Services/api.service';
// import { Router } from '@angular/router';
// import { SweetAlert } from 'src/app/Services/sweetalet.service';
// import { LoaderService } from 'src/app/Services/loader.service';
// import { type } from 'os';
// import { FileUploadService } from 'src/app/Services/file-upload.service';
// import { CommonServices } from 'src/app/Services/common.service';

// export interface User {
//   name: string;
// }
// declare const Compressor;
// @Component({
//   selector: 'app-create-driver',
//   templateUrl: './create-driver.component.html',
//   styleUrls: ['./create-driver.component.css']
// })
// export class CreateDriverComponent implements OnInit {

//   public breadcrumbData = {
//     "Information": "/organization/transport-manager/information",
//     "Vendors": "/organization/transport-manager/information/vendor/view-vendor",
//   };

//   matFormSize = '13px';

//   public addDriverForm: FormGroup;
//   myControl = new FormControl();
//   public stateSelect = indiaStates.IND;
//   options: User[] = [];
//   public stateData = [];
//   filteredOptions: Observable<User[]>;
//   public userType: string;
//   public userData: any;
//   public imageField;

//   public tempProfilePic: any;
//   public tempLicencePic: any;

//   routerLinks: any;
//   public finalCheck: boolean = false;

//   public branchInformation: any = [];
//   public branchlists = [];
//   public shiftInformation: any = [];
//   public shiftlists = [];

//   imageUrl: any;
//   minDate: Date;

//   licenceImage: File | undefined = undefined;
//   licencePreview: string | null = null;
//   licenceUploadContentFile: string | undefined = undefined;
//   @ViewChild('licence') licence: ElementRef;

//   profileImage: File | undefined = undefined;
//   profilePreview: string | null = null;
//   profileContentFile: string | undefined = undefined;
//   @ViewChild('profile') profile: ElementRef;

//   addressProof: File | undefined = undefined;
//   addressProofPreview: string | null = null;
//   addressContentFile: string | undefined = undefined;
//   @ViewChild('address') address: ElementRef;

//   policeCertficate: File | undefined = undefined;
//   policeCertficatePreview: string | null = null;
//   policeCertficateContentFile: string | undefined = undefined;
//   @ViewChild('policeCert') policeCert: ElementRef;

//   resume: File | undefined = undefined;
//   resumePreview: string | null = null;
//   resumeContentFile: string | undefined = undefined;
//   @ViewChild('resum') resum: ElementRef;

//   antecedentReport: File | undefined = undefined;
//   antecedentReportPreview: string | null = null;
//   antecedentContentFile: string | undefined = undefined;
//   @ViewChild('antecedent') antecedent: ElementRef;


//   constructor(
//     public api: ApiService,
//     public storage: StorageService,
//     public router: Router,
//     public swal: SweetAlert,
//     private loader: LoaderService,
//     public file: FileUploadService,
//     public comService: CommonServices
//   ) {
//     this.userType = this.storage.get('userType');
//     this.userData = this.storage.get('vendorID_orgID');
//     let vendorName = this.userData['vendorName'];

//     if (vendorName) {
//       vendorName = this.comService.strTruncate(vendorName, 13);
//       this.breadcrumbData[vendorName] = "/organization/transport-manager/information/vendor/single-view-vendor/" + this.userData.vendorID;
//     } else {
//       this.breadcrumbData['Vendor'] = "/organization/transport-manager/information/vendor/single-view-vendor/" + this.userData.vendorID;
//     }
//     this.routerLinks = "/organization/transport-manager/information/driver/view-driver/" + this.userData.vendorID;
//     this.breadcrumbData['Drivers'] = "organization/transport-manager/information/driver/view-driver/" + this.userData.vendorID;
//     this.breadcrumbData['Create'] = "";
//   }

//   ngOnInit(): void {
//     if (this.userType != 'transport_manager') {
//       this.router.navigate(['/organization/transport-manager/login']);
//     }
//     this.filteredOptions = this.myControl.valueChanges
//       .pipe(
//         startWith(''),
//         map(value => typeof value === 'string' ? value : value.name),
//         map(name => name ? this._filter(name) : this.options.slice())
//       );
//     this.getStateOptions();
//     this.addFormLoad();
//     this.getBranchList();
//     this.getListShift();
//     this.minDate = new Date()
//   }
//   //shift
//   getListShift() {
//     const obj = {
//       orgID: this.storage.get('userInfo').orgID
//     };
//     this.api.ListShift(obj).then((res: any) => {
//       if (res.status == 'success') {
//         this.shiftInformation = res.data;
//       }
//     }).catch((err) => {
//       console.log(err);
//     });
//   }
//   //branch
//   getBranchList() {
//     const obj = {
//       orgID: this.storage.get('userInfo').orgID
//     };
//     this.api.transportManagerBranchList(obj).then((res: any) => {
//       if (res.status == 'success') {
//         this.branchInformation = res.data;
//         this.branchlists = res.data.map(item => {
//           return {
//             "name": item.branchName, value: item.branchID,
//           }
//         });
//       }
//     }).catch((err) => {
//       console.log(err);
//     });
//   }
//   getBranchResult(selected) {
//     this.getShiftFieldData(selected.value);

//   }
//   getShiftFieldData(values) {
//     this.shiftlists = [];
//     if (!Array.isArray(values)) values = [values];
//     this.shiftInformation.map((item) => {
//       let obj = {
//         name: item.shiftName, /* +' '+ this.getBranchName(item.branch), */
//         value: item.shiftID
//       };
//       if (item.branch && values.includes(item.branch)) this.shiftlists.push(obj);
//     })
//   }

//   getName(id, data, key, returnValue) {
//     let result = '';
//     if (!Array.isArray(data)) data = [data];
//     data.filter((item) => {
//       if (item[key] == id) {
//         result = item[returnValue];
//       }
//     })
//     return result;
//   }

//   getBranchName(id) {
//     let name = '';
//     this.branchInformation.filter((e) => {
//       if (e.branchID == id) {
//         name = e.branchName;
//       }
//     });
//     return name;
//   }

//   getStateOptions() {
//     this.stateSelect.forEach(element => {
//       //console.log(element)
//       this.options.push({ name: element })
//     });
//   }
//   addFormLoad() {
//     this.addDriverForm = new FormGroup({
//       name: new FormControl('', [Validators.required]),
//       dob: new FormControl(''), /* , [Validators.required]), */
//       licenceNo: new FormControl('', [Validators.required]),
//       licenceExpiry: new FormControl(''), /* [Validators.required]), */
//       branch: new FormControl('', [Validators.required]),
//       shift: new FormControl('', [Validators.required]),
//       mobile: new FormControl('', [Validators.required, Validators.pattern('[0-9]\\d{9}')]),
//       emergencyContact: new FormControl('', [/* Validators.required, */Validators.pattern('[0-9]\\d{9}')]),
//       bloodGroup: new FormControl(''), /*  [Validators.required]), */
//       address: new FormControl(''), /* [Validators.required]), */
//       city: new FormControl(''), /* [Validators.required]), */
//       state: new FormControl(''), /* [Validators.required]), */
//       country: new FormControl('India'), /* {value:'India',disabled:true} */
//       pincode: new FormControl('', [/* Validators.required,  */Validators.pattern('[0-9]\\d{5}')]),
//       profilePic: new FormControl(''), /* ,[Validators.required]), */
//       licenceUpload: new FormControl('') /* , [Validators.required]), */,
//       addressProof: new FormControl(''),
//       policeCertficate: new FormControl(''),
//       resume: new FormControl(''),
//       antecedentReport: new FormControl('')
//     });

//     this.addDriverForm.controls.country.disable();

//   }
//   public checkError = (controlName: string, errorName: string) => {
//     return this.addDriverForm.controls[controlName].hasError(errorName);
//   }
//   private _filter(name: string): User[] {
//     const filterValue = name.toLowerCase();

//     return this.options.filter(option => option.name.toLowerCase().includes(filterValue));
//   }
//   _keyPress(event: any) {
//     const pattern = /[0-9]/;
//     const inputChar = String.fromCharCode(event.charCode);
//     if (!pattern.test(inputChar)) {
//       event.preventDefault();

//     }
//   }
//   displayFn(user: User): string {
//     this.stateData = [];
//     this.stateData.push(user);
//     //this.addDriverForm.value.patchValue({state:user});
//     return user && user.name ? user.name : '';
//   }
//   /*clear image file*/
//   // clkFun(field) {
//   //   this.addDriverForm.controls[field].patchValue('');
//   //   if(field=='profilePic'){
//   //     this.profileImage='';
//   //   }
//   //   else if(field=='licenceUpload'){
//   //     this.licenceImage='';
//   //   }
//   // }
//   // reUpload(field){
//   //   document.getElementById(field).click();
//   // }

//   // async handleUpload(event,field) {
//   //   let base64;
//   //   if(field=='licenceUpload'){
//   //     this.licenceImage = await this.file.fileHandeleBase64(event);
//   //     base64 = this.licenceImage;
//   //   }
//   //   if(field=='profilePic'){
//   //     this.profileImage = await this.file.fileHandeleBase64(event);
//   //     base64 = this.profileImage;
//   //   }
//   //   if(field=='addressProof'){
//   //     this.addressProof = await this.file.fileHandeleBase64(event);
//   //     base64 = this.addressProof;
//   //   }
//   //   if(field=='policeCertficate'){
//   //     this.policeCertficate = await this.file.fileHandeleBase64(event);
//   //     base64 = this.policeCertficate;
//   //   }
//   //   if(field=='resume'){
//   //     this.resume = await this.file.fileHandeleBase64(event);
//   //     base64 = this.resume;
//   //   }

//   //   this.addDriverForm.controls[field].patchValue(base64);    
//   // }

//   async handleUpload(event: Event, type: string) {
//     const file = (event.target as HTMLInputElement).files?.[0];
//     const maxFileSizeInMB = 1;
//     const maxFileSize = maxFileSizeInMB * 1024 * 1024;
//     const allowedImageTypes = ['image/jpeg', 'image/png', 'image/gif'];
//     const allowedPdfType = 'application/pdf';

//     if (!file) return;

//     const fileType = file.type;
//     const isImageOrPdf = allowedImageTypes.includes(fileType) || fileType === allowedPdfType;

//     if (!isImageOrPdf) {
//       this.handleInvalidFileType(type);
//       return this.showErrorMessage('Invalid file type. Only images and PDFs are allowed.');
//     }

//     if (file.size > maxFileSize) {
//       this.handleFileSizeExceeded(type);
//       return this.showErrorMessage(`File size exceeds ${maxFileSizeInMB} MB`);
//     }

//     this.processFile(file, type, fileType, allowedImageTypes.includes(fileType) ? 'Image' : 'PDF');

//     // if (this.formSubmit) this.validation();
//   }

//   private processFile(file: File, type: string, fileType: string, contentType: string) {
//     const fileReader = new FileReader();
//     fileReader.onload = () => this.updateFormAndPreview(type, file, fileReader.result as string, contentType);
//     fileReader.readAsDataURL(file);
//   }

//   private updateFormAndPreview(type: string, file: File, previewData: string, contentType: string) {
//     switch (type) {
//       case 'profilePic':
//         this.profileImage = file;
//         this.profilePreview = previewData;
//         this.profileContentFile = contentType;
//         this.addDriverForm.controls.profilePic.patchValue(file);
//         break;
//       case 'licenceUpload':
//         this.licenceImage = file;
//         this.licenceUploadContentFile = contentType;
//         this.licencePreview = previewData;
//         this.addDriverForm.controls.licenceUpload.patchValue(file);
//         break;
//       case 'addressProof':
//         this.addressProof = file;
//         this.addressContentFile = contentType;
//         this.addressProofPreview = previewData;
//         this.addDriverForm.controls.addressProof.patchValue(file);
//         break;
//       case 'policeCertficate':
//         this.policeCertficate = file;
//         this.policeCertficateContentFile = contentType;
//         this.policeCertficatePreview = previewData;
//         this.addDriverForm.controls.policeCertficate.patchValue(file);
//         break;
//       case 'resume':
//         this.resume = file;
//         this.resumeContentFile = contentType;
//         this.resumePreview = previewData;
//         this.addDriverForm.controls.resume.patchValue(file);
//         break;
//       case 'antecedentReport':
//         this.antecedentReport = file;
//         this.antecedentContentFile = contentType;
//         this.antecedentReportPreview = previewData;
//         this.addDriverForm.controls.antecedentReport.patchValue(file);
//         break;
//     }
//   }

//   private handleInvalidFileType(type: string) {
//     this.resetFileFields(type);
//   }

//   private handleFileSizeExceeded(type: string) {
//     this.resetFileFields(type);
//   }

//   private resetFileFields(type: string) {
//     switch (type) {
//       case 'profilePic':
//         this.profileImage = null;
//         this.profilePreview = null;
//         this.profileContentFile = null;
//         this.addDriverForm.controls.profilePic.reset();
//         this.clearInputField(this.profile);
//         break;
//       case 'licenceUpload':
//         this.licenceImage = null;
//         this.licencePreview = null;
//         this.licenceUploadContentFile = null;
//         this.addDriverForm.controls.licenceUpload.reset();
//         this.clearInputField(this.licence);
//         break;
//       case 'addressProof':
//         this.addressProof = null;
//         this.addressProofPreview = null;
//         this.addressContentFile = null;
//         this.addDriverForm.controls.addressProof.reset();
//         this.clearInputField(this.address);
//         break;
//       case 'policeCertficate':
//         this.policeCertficate = null;
//         this.policeCertficatePreview = null;
//         this.policeCertficateContentFile = null;
//         this.addDriverForm.controls.policeCertficate.reset();
//         this.clearInputField(this.policeCert);
//         break;
//       case 'resume':
//         this.resume = null;
//         this.resumePreview = null;
//         this.resumeContentFile = null;
//         this.addDriverForm.controls.resume.reset();
//         this.clearInputField(this.resum);
//         break;
//       case 'antecedentReport':
//         this.antecedentReport = null;
//         this.antecedentReportPreview = null;
//         this.antecedentContentFile = null;
//         this.addDriverForm.controls.antecedentReport.reset();
//         this.clearInputField(this.antecedent)  
//        break;
//     }
//   }

//   private clearInputField(inputElement: ElementRef) {
//     if (inputElement) inputElement.nativeElement.value = '';
//   }

//   private showErrorMessage(message: string) {
//     this.swal.swalFunction('error', 'error', message, 5000);
//   }


//   reUpload(field: string) {
//     const fileFieldMap = {
//       'profile': this.profile,
//       'licence': this.licence,
//       'address': this.address,
//       'policeCert': this.policeCert,
//       'resum': this.resum,
//       'antecedent': this.antecedent
//     };

//     const fileInput = fileFieldMap[field];
//     if (fileInput) {
//       fileInput.nativeElement.click();
//     }
//   }

//   cancelImage(type: string) {
//     if (type == 'profile') {
//       this.addDriverForm.controls.profilePic.patchValue('');
//       this.profileImage = undefined;
//     } if (type == 'licenceUpload') {
//       this.addDriverForm.controls.licenceUpload.patchValue('');
//       this.licenceImage = undefined;
//     } if (type == 'addressProof') {
//       this.addDriverForm.controls.addressProof.patchValue('');
//       this.addressProof = undefined;
//     } if (type == 'policeCertficate') {
//       this.addDriverForm.controls.policeCertficate.patchValue('');
//       this.policeCertficate = undefined;
//     } if (type == 'resume') {
//       this.addDriverForm.controls.resume.patchValue('');
//       this.resume = undefined;
//     } if (type == 'antecedentReport') {
//       this.addDriverForm.controls.antecedentReport.patchValue('');
//       this.antecedentReport = undefined;
//     }
//   }

//   onSubmit() {
//     this.finalCheck = true;
//     if (!this.addDriverForm.valid) return;

//     const obj = {
//       orgID: this.userData.orgID,
//       vendorID: this.userData.vendorID,
//     };


//     let keys = Object.keys(this.addDriverForm.value);
//     if (keys.length > 0) {
//       for (let k = 0; k < keys.length; k++) {
//         let key = keys[k];
//         if (this.addDriverForm.value[key] != '' &&
//           this.addDriverForm.value[key] != [] &&
//           this.addDriverForm.value[key] != {}) {
//           obj[key] = this.addDriverForm.value[key];
//         }
//       }
//     }
//     if (obj['mobile']) obj['mobile'] = parseInt(obj['mobile']);
//     if (obj['emergencyContact']) obj['emergencyContact'] = parseInt(obj['emergencyContact']);
//     if (obj['dob']) obj['dob'] = new Date(obj['dob']).getTime();
//     if (obj['licenceExpiry']) obj['licenceExpiry'] = new Date(obj['licenceExpiry']).getTime();

//     if (this.profileImage != undefined) {
//       obj['profile'] = this.profileImage;
//       obj['profileContentFile'] = this.profileContentFile;
//       delete obj['profilePic']
//     } else { delete obj['profilePic'] }

//     if (this.licenceImage != undefined) {
//       obj['licenceUpload'] = this.licenceImage;
//       obj['licenceUploadContentFile'] = this.licenceUploadContentFile;
//     } else { delete obj['licenceUpload'] }

//     if (this.policeCertficate != undefined) {
//       obj['policeCertficate'] = this.policeCertficate;
//       obj['policeCertficateContentFile'] = this.policeCertficateContentFile;
//     }
//     else {
//       delete obj['policeCertficate'];
//     }
//     if (this.resume != undefined) {
//       obj['resumefiles'] = this.resume;
//       obj['resumeContentFile'] = this.resumeContentFile;
//       delete obj['resume'];
//     } else {
//       delete obj['resumefiles'];
//       delete obj['resume'];
//     }
//     if (this.addressProof != undefined) {
//       obj['addressfiles'] = this.addressProof;
//       obj['addressContentFile'] = this.addressContentFile;
//       delete obj['addressProof'];
//     } else {
//       delete obj['addressProof'];
//     }
//     if (this.antecedentReport != undefined) {
//       obj['antecedentReport'] = this.antecedentReport;
//       obj['antecedentContentFile'] = this.antecedentContentFile;
//     }
//     let url = 'organization/driver/createDriver';
//     this.api.transportManagerFormDataCreate(obj, url, (res: any) => {
//       if (res['responseJSON']['status'] == 'Success') {
//         this.profileImage = undefined;
//         this.licenceImage = undefined;
//         this.addressProof = undefined;
//         this.policeCertficate = undefined;
//         this.resume = undefined;
//         this.swal.swalFunction(res['responseJSON'].status, res['responseJSON'].status, res['responseJSON'].message, 2000);
//         this.router.navigate([this.routerLinks]);
//       }
//       if (res['responseJSON'].status == 'failure') {
//         this.loader.hide();
//         this.swal.swalFunction('error', res['responseJSON'].status, res['responseJSON'].message, 3000);
//       }
//     })

//   }
//   previewImage(imageUrl) {
//     // this.imageUrl = image;
//     if (imageUrl.startsWith('data:image')) {
//       // Open the base64 image in a new tab
//       const newWindow = window.open();
//       if (newWindow) {
//         newWindow.document.write(`<img src="${imageUrl}" style="width:100%;">`);
//         newWindow.document.title = "Image Preview";
//       }
//     } else {
//       window.open(imageUrl, '_blank');
//     }
//   }

//   openPdf(pdfUrl: string) {
//     if (pdfUrl.startsWith('data:application/pdf;base64,')) {
//       const newWindow = window.open();
//       if (newWindow) {
//         newWindow.document.write(`
//           <html>
//             <head>
//               <title>PDF Preview</title>
//             </head>
//             <body style="margin: 0; padding: 0; overflow: hidden;">
//               <embed src="${pdfUrl}" type="application/pdf" width="100%" height="100%" />
//             </body>
//           </html>
//         `);
//       }
//     } else {
//       // Handle URL-based PDF
//       window.open(pdfUrl, '_blank');
//     }
//   }
// }


import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import indiaStates from '../../../../../../../assets/js/india.state.list.json';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { StorageService } from 'src/app/Services/storage.service';
import { ApiService } from 'src/app/Services/api.service';
import { Router } from '@angular/router';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { LoaderService } from 'src/app/Services/loader.service';
import { type } from 'os';
import { FileUploadService } from 'src/app/Services/file-upload.service';
import { CommonServices } from 'src/app/Services/common.service';

export interface User {
  name: string;
}
declare const Compressor;
@Component({
  selector: 'app-create-driver',
  templateUrl: './create-driver.component.html',
  styleUrls: ['./create-driver.component.css']
})
export class CreateDriverComponent implements OnInit {

  public breadcrumbData = {
    "Information": "/organization/transport-manager/information",
    "Vendors": "/organization/transport-manager/information/vendor/view-vendor",
  };

  matFormSize = '13px';

  public addDriverForm: FormGroup;
  myControl = new FormControl();
  public stateSelect = indiaStates.IND;
  options: User[] = [];
  public stateData = [];
  filteredOptions: Observable<User[]>;
  public userType: string;
  public userData: any;
  public imageField;

  public tempProfilePic: any;
  public tempLicencePic: any;

  routerLinks: any;
  public finalCheck: boolean = false;

  public branchInformation: any = [];
  public branchlists = [];
  public shiftInformation: any = [];
  public shiftlists = [];

  imageUrl: any;
  minDate: Date;

  licenceImage: File | undefined = undefined;
  licencePreview: string | null = null;
  licenceUploadContentFile: string | undefined = undefined;
  @ViewChild('licence') licence: ElementRef;

  profileImage: File | undefined = undefined;
  profilePreview: string | null = null;
  profileContentFile: string | undefined = undefined;
  @ViewChild('profile') profile: ElementRef;

  addressProof: File | undefined = undefined;
  addressProofPreview: string | null = null;
  addressContentFile: string | undefined = undefined;
  @ViewChild('address') address: ElementRef;

  policeCertficate: File | undefined = undefined;
  policeCertficatePreview: string | null = null;
  policeCertficateContentFile: string | undefined = undefined;
  @ViewChild('policeCert') policeCert: ElementRef;

  resume: File | undefined = undefined;
  resumePreview: string | null = null;
  resumeContentFile: string | undefined = undefined;
  @ViewChild('resum') resum: ElementRef;

  antecedentReport: File | undefined = undefined;
  antecedentReportPreview: string | null = null;
  antecedentContentFile: string | undefined = undefined;
  @ViewChild('antecedent') antecedent: ElementRef;


  constructor(
    public api: ApiService,
    public storage: StorageService,
    public router: Router,
    public swal: SweetAlert,
    private loader: LoaderService,
    public file: FileUploadService,
    public comService: CommonServices
  ) {
    this.userType = this.storage.get('userType');
    this.userData = this.storage.get('vendorID_orgID');
    let vendorName = this.userData['vendorName'];

    if (vendorName) {
      vendorName = this.comService.strTruncate(vendorName, 13);
      this.breadcrumbData[vendorName] = "/organization/transport-manager/information/vendor/single-view-vendor/" + this.userData.vendorID;
    } else {
      this.breadcrumbData['Vendor'] = "/organization/transport-manager/information/vendor/single-view-vendor/" + this.userData.vendorID;
    }
    this.routerLinks = "/organization/transport-manager/information/driver/view-driver/" + this.userData.vendorID;
    this.breadcrumbData['Drivers'] = "organization/transport-manager/information/driver/view-driver/" + this.userData.vendorID;
    this.breadcrumbData['Create'] = "";
  }

  ngOnInit(): void {
    if (this.userType != 'transport_manager') {
      this.router.navigate(['/organization/transport-manager/login']);
    }
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this._filter(name) : this.options.slice())
      );
    this.getStateOptions();
    this.addFormLoad();
    this.getBranchList();
    this.getListShift();
    this.minDate = new Date()
  }
  //shift
  getListShift() {
    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.ListShift(obj).then((res: any) => {
      if (res.status == 'success') {
        this.shiftInformation = res.data;
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  //branch
  getBranchList() {
    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.transportManagerBranchList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.branchInformation = res.data;
        this.branchlists = res.data.map(item => {
          return {
            "name": item.branchName, value: item.branchID,
          }
        });
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  getBranchResult(selected) {
    this.getShiftFieldData(selected.value);

  }
  getShiftFieldData(values) {
    this.shiftlists = [];
    if (!Array.isArray(values)) values = [values];
    this.shiftInformation.map((item) => {
      let obj = {
        name: item.shiftName, /* +' '+ this.getBranchName(item.branch), */
        value: item.shiftID
      };
      if (item.branch && values.includes(item.branch)) this.shiftlists.push(obj);
    })
  }

  getName(id, data, key, returnValue) {
    let result = '';
    if (!Array.isArray(data)) data = [data];
    data.filter((item) => {
      if (item[key] == id) {
        result = item[returnValue];
      }
    })
    return result;
  }

  getBranchName(id) {
    let name = '';
    this.branchInformation.filter((e) => {
      if (e.branchID == id) {
        name = e.branchName;
      }
    });
    return name;
  }

  getStateOptions() {
    this.stateSelect.forEach(element => {
      //console.log(element)
      this.options.push({ name: element })
    });
  }
  addFormLoad() {
    this.addDriverForm = new FormGroup({
      name: new FormControl('', [Validators.required]),
      dob: new FormControl('', [Validators.required]), 
      licenceNo: new FormControl('', [Validators.required]),
      licenceExpiry: new FormControl('', [Validators.required]), 
      branch: new FormControl([], [Validators.required]),
      shift: new FormControl('', [Validators.required]),
      isActive: new FormControl('', [Validators.required]),
      mobile: new FormControl('', [Validators.required, Validators.pattern('[0-9]\\d{9}')]),
      emergencyContact: new FormControl('', [Validators.required, Validators.pattern('[0-9]\\d{9}')]),
      bloodGroup: new FormControl(''), /*  [Validators.required]), */
      address: new FormControl('',[Validators.required]), /* [), */
      city: new FormControl('',[Validators.required]),
      state: new FormControl('',[Validators.required]),
      country: new FormControl('India'), /* {value:'India',disabled:true} */
      pincode: new FormControl('', [ Validators.required, Validators.pattern('[0-9]\\d{5}')]),
      profilePic: new FormControl(''), /* ,[Validators.required]), */
      licenceUpload: new FormControl('') /* , [Validators.required]), */,
      addressProof: new FormControl(''),
      policeCertficate: new FormControl(''),
      resume: new FormControl(''),
      antecedentReport: new FormControl('')
    });

    this.addDriverForm.controls.country.disable();

  }
  public checkError = (controlName: string, errorName: string) => {
    return this.addDriverForm.controls[controlName].hasError(errorName);
  }
  private _filter(name: string): User[] {
    const filterValue = name.toLowerCase();

    return this.options.filter(option => option.name.toLowerCase().includes(filterValue));
  }
  _keyPress(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();

    }
  }
  displayFn(user: User): string {
    this.stateData = [];
    this.stateData.push(user);
    //this.addDriverForm.value.patchValue({state:user});
    return user && user.name ? user.name : '';
  }
  /*clear image file*/
  // clkFun(field) {
  //   this.addDriverForm.controls[field].patchValue('');
  //   if(field=='profilePic'){
  //     this.profileImage='';
  //   }
  //   else if(field=='licenceUpload'){
  //     this.licenceImage='';
  //   }
  // }
  // reUpload(field){
  //   document.getElementById(field).click();
  // }

  // async handleUpload(event,field) {
  //   let base64;
  //   if(field=='licenceUpload'){
  //     this.licenceImage = await this.file.fileHandeleBase64(event);
  //     base64 = this.licenceImage;
  //   }
  //   if(field=='profilePic'){
  //     this.profileImage = await this.file.fileHandeleBase64(event);
  //     base64 = this.profileImage;
  //   }
  //   if(field=='addressProof'){
  //     this.addressProof = await this.file.fileHandeleBase64(event);
  //     base64 = this.addressProof;
  //   }
  //   if(field=='policeCertficate'){
  //     this.policeCertficate = await this.file.fileHandeleBase64(event);
  //     base64 = this.policeCertficate;
  //   }
  //   if(field=='resume'){
  //     this.resume = await this.file.fileHandeleBase64(event);
  //     base64 = this.resume;
  //   }

  //   this.addDriverForm.controls[field].patchValue(base64);    
  // }

  async handleUpload(event: Event, type: string) {
    const file = (event.target as HTMLInputElement).files?.[0];
    const maxFileSizeInMB = 1;
    const maxFileSize = maxFileSizeInMB * 1024 * 1024;
    const allowedImageTypes = ['image/jpeg', 'image/png', 'image/gif'];
    const allowedPdfType = 'application/pdf';

    if (!file) return;

    const fileType = file.type;
    const isImageOrPdf = allowedImageTypes.includes(fileType) || fileType === allowedPdfType;

    if (!isImageOrPdf) {
      this.handleInvalidFileType(type);
      return this.showErrorMessage('Invalid file type. Only images and PDFs are allowed.');
    }

    if (file.size > maxFileSize) {
      this.handleFileSizeExceeded(type);
      return this.showErrorMessage(`File size exceeds ${maxFileSizeInMB} MB`);
    }

    this.processFile(file, type, fileType, allowedImageTypes.includes(fileType) ? 'Image' : 'PDF');

    // if (this.formSubmit) this.validation();
  }

  private processFile(file: File, type: string, fileType: string, contentType: string) {
    const fileReader = new FileReader();
    fileReader.onload = () => this.updateFormAndPreview(type, file, fileReader.result as string, contentType);
    fileReader.readAsDataURL(file);
  }

  private updateFormAndPreview(type: string, file: File, previewData: string, contentType: string) {
    switch (type) {
      case 'profilePic':
        this.profileImage = file;
        this.profilePreview = previewData;
        this.profileContentFile = contentType;
        this.addDriverForm.controls.profilePic.patchValue(file);
        break;
      case 'licenceUpload':
        this.licenceImage = file;
        this.licenceUploadContentFile = contentType;
        this.licencePreview = previewData;
        this.addDriverForm.controls.licenceUpload.patchValue(file);
        break;
      case 'addressProof':
        this.addressProof = file;
        this.addressContentFile = contentType;
        this.addressProofPreview = previewData;
        this.addDriverForm.controls.addressProof.patchValue(file);
        break;
      case 'policeCertficate':
        this.policeCertficate = file;
        this.policeCertficateContentFile = contentType;
        this.policeCertficatePreview = previewData;
        this.addDriverForm.controls.policeCertficate.patchValue(file);
        break;
      case 'resume':
        this.resume = file;
        this.resumeContentFile = contentType;
        this.resumePreview = previewData;
        this.addDriverForm.controls.resume.patchValue(file);
        break;
      case 'antecedentReport':
        this.antecedentReport = file;
        this.antecedentContentFile = contentType;
        this.antecedentReportPreview = previewData;
        this.addDriverForm.controls.antecedentReport.patchValue(file);
        break;
    }
  }

  private handleInvalidFileType(type: string) {
    this.resetFileFields(type);
  }

  private handleFileSizeExceeded(type: string) {
    this.resetFileFields(type);
  }

  private resetFileFields(type: string) {
    switch (type) {
      case 'profilePic':
        this.profileImage = null;
        this.profilePreview = null;
        this.profileContentFile = null;
        this.addDriverForm.controls.profilePic.reset();
        this.clearInputField(this.profile);
        break;
      case 'licenceUpload':
        this.licenceImage = null;
        this.licencePreview = null;
        this.licenceUploadContentFile = null;
        this.addDriverForm.controls.licenceUpload.reset();
        this.clearInputField(this.licence);
        break;
      case 'addressProof':
        this.addressProof = null;
        this.addressProofPreview = null;
        this.addressContentFile = null;
        this.addDriverForm.controls.addressProof.reset();
        this.clearInputField(this.address);
        break;
      case 'policeCertficate':
        this.policeCertficate = null;
        this.policeCertficatePreview = null;
        this.policeCertficateContentFile = null;
        this.addDriverForm.controls.policeCertficate.reset();
        this.clearInputField(this.policeCert);
        break;
      case 'resume':
        this.resume = null;
        this.resumePreview = null;
        this.resumeContentFile = null;
        this.addDriverForm.controls.resume.reset();
        this.clearInputField(this.resum);
        break;
      case 'antecedentReport':
        this.antecedentReport = null;
        this.antecedentReportPreview = null;
        this.antecedentContentFile = null;
        this.addDriverForm.controls.antecedentReport.reset();
        this.clearInputField(this.antecedent)  
       break;
    }
  }

  private clearInputField(inputElement: ElementRef) {
    if (inputElement) inputElement.nativeElement.value = '';
  }

  private showErrorMessage(message: string) {
    this.swal.swalFunction('error', 'error', message, 5000);
  }


  reUpload(field: string) {
    const fileFieldMap = {
      'profile': this.profile,
      'licence': this.licence,
      'address': this.address,
      'policeCert': this.policeCert,
      'resum': this.resum,
      'antecedent': this.antecedent
    };

    const fileInput = fileFieldMap[field];
    if (fileInput) {
      fileInput.nativeElement.click();
    }
  }

  cancelImage(type: string) {
    if (type == 'profile') {
      this.addDriverForm.controls.profilePic.patchValue('');
      this.profileImage = undefined;
    } if (type == 'licenceUpload') {
      this.addDriverForm.controls.licenceUpload.patchValue('');
      this.licenceImage = undefined;
    } if (type == 'addressProof') {
      this.addDriverForm.controls.addressProof.patchValue('');
      this.addressProof = undefined;
    } if (type == 'policeCertficate') {
      this.addDriverForm.controls.policeCertficate.patchValue('');
      this.policeCertficate = undefined;
    } if (type == 'resume') {
      this.addDriverForm.controls.resume.patchValue('');
      this.resume = undefined;
    } if (type == 'antecedentReport') {
      this.addDriverForm.controls.antecedentReport.patchValue('');
      this.antecedentReport = undefined;
    }
  }

  onSubmit() {
    this.finalCheck = true;
    if (!this.addDriverForm.valid) return;

    const obj = {
      orgID: this.userData.orgID,
      vendorID: this.userData.vendorID,
    };


    let keys = Object.keys(this.addDriverForm.value);
    if (keys.length > 0) {
      for (let k = 0; k < keys.length; k++) {
        let key = keys[k];
        if (this.addDriverForm.value[key] != '' &&
          this.addDriverForm.value[key] != [] &&
          this.addDriverForm.value[key] != {}) {
          obj[key] = this.addDriverForm.value[key];
        }
      }
    }
    if (obj['mobile']) obj['mobile'] = parseInt(obj['mobile']);
    if (obj['emergencyContact']) obj['emergencyContact'] = parseInt(obj['emergencyContact']);
    if (obj['dob']) obj['dob'] = new Date(obj['dob']).getTime();
    if (obj['licenceExpiry']) obj['licenceExpiry'] = new Date(obj['licenceExpiry']).getTime();

    if (this.profileImage != undefined) {
      obj['profile'] = this.profileImage;
      obj['profileContentFile'] = this.profileContentFile;
      delete obj['profilePic']
    } else { delete obj['profilePic'] }

    if (this.licenceImage != undefined) {
      obj['licenceUpload'] = this.licenceImage;
      obj['licenceUploadContentFile'] = this.licenceUploadContentFile;
    } else { delete obj['licenceUpload'] }

    if (this.policeCertficate != undefined) {
      obj['policeCertficate'] = this.policeCertficate;
      obj['policeCertficateContentFile'] = this.policeCertficateContentFile;
    }
    else {
      delete obj['policeCertficate'];
    }
    if (this.resume != undefined) {
      obj['resumefiles'] = this.resume;
      obj['resumeContentFile'] = this.resumeContentFile;
      delete obj['resume'];
    } else {
      delete obj['resumefiles'];
      delete obj['resume'];
    }
    if (this.addressProof != undefined) {
      obj['addressfiles'] = this.addressProof;
      obj['addressContentFile'] = this.addressContentFile;
      delete obj['addressProof'];
    } else {
      delete obj['addressProof'];
    }
    if (this.antecedentReport != undefined) {
      obj['antecedentReport'] = this.antecedentReport;
      obj['antecedentContentFile'] = this.antecedentContentFile;
    }
    let url = 'organization/driver/createDriver';
    this.api.transportManagerFormDataCreate(obj, url, (res: any) => {
      if (res['responseJSON']['status'] == 'Success') {
        this.profileImage = undefined;
        this.licenceImage = undefined;
        this.addressProof = undefined;
        this.policeCertficate = undefined;
        this.resume = undefined;
        this.swal.swalFunction(res['responseJSON'].status, res['responseJSON'].status, res['responseJSON'].message, 2000);
        this.router.navigate([this.routerLinks]);
      }
      if (res['responseJSON'].status == 'failure') {
        this.loader.hide();
        this.swal.swalFunction('error', res['responseJSON'].status, res['responseJSON'].message, 3000);
      }
    })

  }
  previewImage(imageUrl) {
    // this.imageUrl = image;
    if (imageUrl.startsWith('data:image')) {
      // Open the base64 image in a new tab
      const newWindow = window.open();
      if (newWindow) {
        newWindow.document.write(`<img src="${imageUrl}" style="width:100%;">`);
        newWindow.document.title = "Image Preview";
      }
    } else {
      window.open(imageUrl, '_blank');
    }
  }

  openPdf(pdfUrl: string) {
    if (pdfUrl.startsWith('data:application/pdf;base64,')) {
      const newWindow = window.open();
      if (newWindow) {
        newWindow.document.write(`
          <html>
            <head>
              <title>PDF Preview</title>
            </head>
            <body style="margin: 0; padding: 0; overflow: hidden;">
              <embed src="${pdfUrl}" type="application/pdf" width="100%" height="100%" />
            </body>
          </html>
        `);
      }
    } else {
      // Handle URL-based PDF
      window.open(pdfUrl, '_blank');
    }
  }
}
